export const serverApiPrefix = '/api/graphql'
export function getEndpoint(operation, operationName) {
  return serverApiPrefix + '/' + operation + '/' + operationName
}